import React, { useState} from "react";
import ContactHandler from "../../Apihander/Contact/ContactHandler";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { successToast, errorToast } from "../../utils/notificationUtils";
import { useForm } from "react-hook-form";
import '../../css/login.css'



const Support = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();

    const navigate = useNavigate()
    const [load, setLoading] = useState(false)


    const onsubmit = async (payload) => {
        try {
            setLoading(true)
            const data = await ContactHandler.doHandelContact(payload)
            if (data.statusCode === 200) {
                successToast(data.message)
                navigate('/')
                setLoading(false)
            } else {
                const errorMessage =
                    data?.response?.data?.message || data.message || "An error occurred";
                errorToast(errorMessage)
                setLoading(false)
            }

        } catch (error) {
            console.log('Error on Contact :', error)
            const errorMessage =
                error?.response?.data?.message || error.message || "An error occurred";
            errorToast(errorMessage);
            setLoading(false)

        }
    }



    return (
        <>
            <div className="container">
                <div style={{ padding: '45px 0px' }}>
                    <div className=" text-center" style={{
                        padding: '100px',
                        backgroundImage: "url('/img/support.png')",
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        width: '100%',
                        height: '100%',
                        borderRadius: '10px'
                    }}>
                        <span className="" style={{ fontFamily: 'Metropolis', fontSize: '34px', fontWeight: '700', lineHeight: '40px', letterSpacing: '-4%' }}>Support</span>
                    </div>
                </div>
                <div className=" d-flex justify-content-center text-center" style={{ padding: '44px 0px' }}>
                    <form onSubmit={handleSubmit(onsubmit)}
                        noValidate
                    >
                        <div className="row justify-content-between text-left">
                            <div className="form-group col-sm-12 col-md-6 flex-column d-flex">
                                <input type="text" id="name" name="name" placeholder="Enter your name"
                                    className={`form-control custom-input-field ${errors.name ? 'error' : ''}`}
                                    style={{ padding: '16px 66px 16px 20px', borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                    {...register("name", {
                                        required: 'This field is required',
                                        minLength: {
                                            value: 4,
                                            message: 'Name should be more than 3 letters'
                                        }
                                    })} />
                                {errors.name && <span className="error-message">{errors.name.message}</span>}

                            </div>
                            <div className="form-group col-sm-12 col-md-6 flex-column d-flex">
                                <input type="text" id="email" name="email" placeholder="Enter your email"
                                    // className="form-control input-field"
                                    className={`form-control custom-input-field ${errors.email ? 'error' : ''}`}

                                    style={{ padding: '16px 66px 16px 20px', borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                    {...register("email", {
                                        required: 'This field is required',
                                        pattern: {
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                            message: 'Enter a valid email address'
                                        }
                                    })}
                                />
                                {errors.email && <span className="error-message">{errors.email.message}</span>}

                            </div>
                        </div>
                        <div className="row justify-content-between text-left  my-4">
                            <div className="form-group col-12 flex-column d-flex">
                                <textarea id="message" name="message" placeholder="Enter your message"
                                    //  className="form-control input-field"
                                    className={`form-control custom-input-field ${errors.message ? 'error' : ''}`}
                                    style={{ resize: "none", padding: '16px 66px 16px 20px', borderRadius: '8px', border: '1.5px solid #E2E8F0' }}
                                    {...register("message", {
                                        required: 'This field is required',
                                        minLength: {
                                            value: 0,
                                            message: 'message should be more than 10 letters'
                                        }
                                    })} />

                                {errors.message && <span className="error-message">{errors.message.message}</span>}

                            </div>
                        </div>
                        <div className="row justify-content-center my-4">
                            <div className="form-group col-sm-6">
                                <button type='submit'
                                    style={{ width: '203px', height: '54px', border: 'none', borderRadius: '8px', background: '#334155', color: 'white', cursor: load ? 'not-allowed' : 'pointer' }}
                                    disabled={load}>
                                    {load ? (
                                        <>
                                            <div
                                                className="spinner-border"
                                                role="status"
                                                style={{ width: "1.5rem", height: "1.5rem" }}
                                            >
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </>
                                    ) : (
                                        <span style={{ fontFamily: 'Metropolis', fontWeight: '700', font: '16px', lineHeight: '20px', }}>Submit</span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div >
        </>
    )

}

export default Support;